import React from "react";

const styles = {
  attachmentImage: {
    maxHeight: "inherit",
    maxWidth: "inherit",
    minHeight: "inherit",
    minWidth: "inherit",
    objectFit: "cover",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  attachmentText: {
    fontWeight: "500",
    position: "absolute",
    top: "10px",
    left: "20px",
  },
};

export default ({ attachmentSrc }) => {
  const classes = styles;

  return (
    <div style={classes.attachmentImage}>
      <span style={classes.attachmentText}>Audio</span>
      <span
        className="material-icons"
        style={{
          fontSize: "65px",
        }}
      >
        play_circle_filled
      </span>
    </div>
  );
};
